/**
 * The path prefix for all static assets. This application shares the
 * redbull.com domain with many other apps, so assets are served from a
 * dedicated subpath via an Akamai CDN rule.
 */
export const PUBLIC_ASSET_PREFIX = "/energydrink/v1/resources";

export const FLAGS_API_PREFIX =
  "https://rbds-static.redbull.com/@cosmos/foundation/latest/flags/cosmos-flag-";

/**
 * Asset "Proxy" Routes
 *
 * These routes are necessary because we have had issues in the past with
 * these upstream sources being geo-blocked in certain countries with a
 * heavy-handed approach to net-neutrality (*cough China cough*).
 *
 * Additionally, PCS eats through bandwidth and this lets us host images
 * cheaper via Akamai.
 *
 * In the front-end, we have to re-write image URLs to use these proxy
 * routes instead of the source URL, so that the browser never makes a
 * direct connection with any of these sources.
 *
 * leave the `https:` off the start of Storyblok URLs (opinionated)
 *
 * TIP: setting an invalid URL is a way to check if any assets are not going through Akamai!
 */
export const CONTENTFUL_IMAGE_BASE_URL = `https://www.redbull.com/energydrink/v1/resources/contentful/images`;
export const CONTENTFUL_VIDEO_BASE_URL = `https://www.redbull.com/energydrink/v1/resources/contentful/videos`;
export const STORYBLOK_IMAGE_BASE_URL = `//www.redbull.com/energydrink/v1/resources/storyblok/images`;
export const STORYBLOK_VIDEO_BASE_URL = `//www.redbull.com/energydrink/v1/resources/storyblok/videos`;

/**
 * Cloudinary cloud name used for image transformations (e.g. meta image generation, fetch).
 */
export const CLOUDINARY_CLOUD_NAME = "redbull-pcs";
